import React, {useState, useEffect} from 'react';
import { useString } from '../utils/useString';
import { AutoCompleteSelect } from '../autocomplete/select/auto-complete-select';

import { SugestaoVenda } from './sugestao-venda';


import {faSearch} from '@fortawesome/pro-duotone-svg-icons';

const useVendasSearchInterface = (getApi) => {

    let [dataStore, setDataStore] = useState({});
    let {strContem} = useString()
    
    useEffect(() => {
        onSearch();
    },[])
  
    const onSearch = async (query) => {
      const api = await getApi();
      console.log(api);
      const result = await api.get("/vendas/sugestoes", {
                                        params: { query }
                                    });
      const newDataStore = Object.assign(result.data);
      setDataStore(newDataStore);
      return newDataStore;
      
    }
  
    const onFilter = (query, dataStore) => {
      const keys = Object.keys(dataStore);
      const categorias = [];

      keys.forEach(key => {
        let itensCategoria = [];
        itensCategoria = dataStore[key].filter((venda) => {
                console.log(venda,strContem(venda.nome,query))
                return ((venda.numeroVenda == query || query == "") ||
                        strContem(venda.nome,query)
                       )
            }).map(venda => {
                return {
                    value: key + "_" + venda.idVenda,
                    label: <SugestaoVenda venda={venda} ></SugestaoVenda>
                }
            });
        if(itensCategoria.length){
            categorias.push({
                label: <span>{key}</span>,
                options: itensCategoria
            })

        }
      })
      console.log(categorias)
      return categorias
  
    };
  
    
  
    return {dataStore, onSearch, onFilter}
  
  
}



const AutoCompleteVendasSelect = ({searchProps, getApi, autoCompleteProps, onSelect=(q)=>{}}) => {
    
    const {dataStore, onSearch, onFilter} = useVendasSearchInterface(getApi);
    

    const onSelectHandle = (value) => {
        const splitedValue = value.split("_");
        const tipo = splitedValue[0];
        const itemSelecionado = dataStore[tipo].filter(venda => {
            return (venda.idVenda == splitedValue[1]);
        })[0];

        itemSelecionado.tipo = tipo;

        onSelect && onSelect(itemSelecionado);
    }

  
    return (
        <AutoCompleteSelect
            autoCompleteProps={autoCompleteProps}
            searchProps={searchProps}
            searchInterface={{dataStore, onSearch, onFilter}}
            onSelect={onSelectHandle}
            icon={faSearch}
        ></AutoCompleteSelect>
    );
}

export { AutoCompleteVendasSelect }